<template lang="html">
  <div class="container">

    <div class="header">
      <i class="icon-fanhui iconfont icon back" @click="back"></i>
      <p>项目签约明细</p>
      <!-- <div class="filter" v-if="!isFilter">
        <span class="btn" @click="showFilter(1)">{{filterArea.name}}<i class="icon-sanjiaoxiala icon iconfont"></i></span>
        <span class="btn time" @click="showFilter(2)">{{filterTime.name}}<i class="icon-sanjiaoxiala icon iconfont"></i></span>
      </div> -->
      <!-- <nav>
        <a href="javascript:void(0);" :class="{'yes':filterType == 1}" >
          <span @click="showFilter(1)">
            {{filterArea.name}}
            <i class="iconfont icon-sanjiaoxiabiao"></i>
          </span>
        </a>
        <a href="javascript:void(0);" :class="{'yes':filterType == 2}" >
          <span @click="showFilter(2)">
            {{filterTime.name}}
            <i class="iconfont icon-sanjiaoxiabiao"></i>
          </span>
        </a>
      </nav> -->



    </div>


    <p class="select">
      {{this.begin_time}}-{{this.end_time}},{{c_region[0]=='0'?'全部':getCurrentRegion()}}
      <i class="icon iconfont icon-shaixuan" @click="filter"></i>
    </p>



    <div class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <!--筛选-->
    <div class="selbox" v-if="isFilter">
      <p>筛选</p>

      <p class="content">
        时间
      </p>

      <ul class="listtime">
        <mt-picker :slots="slots" @change="onDateChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
      </ul>

      <p  class="content">
        区域
      </p>
      <!-- <ul  class="listtime">
        <li :class="{'true': index == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(index)" >{{item}}</li>
      </ul> -->
       <ul  class="listtime">
        <li :class="{'true': item.id == c_region[0]}" v-for="(item,index) in region_list" @click="onRegionChang(item.id)" :key="item.id" >{{item.name}}</li>
      </ul>


      <p class="btnyes" @click="confirmFilter">确定</p>
    </div>



    <!-- <div class="zhezhao" v-if="isFilter" @click="isFilter = false; filterType = null"></div> -->


<!--集团-->
    <!-- <div class="downlist" v-if="filterType == 1 && isFilter">
      <ul>
        <li v-for="item in regionData" @click="confirmFilter(1,item)" :class="{'testcol':filterArea.name == item.name}">
          {{item.name}}
          <i class="icon-duihao iconfont click" v-if="filterArea.name == item.name"></i>
        </li>
      </ul>
    </div> -->



<!--时间-->
    <!-- <div class="downlist" v-if="filterType == 2 && isFilter">
      <ul>
        <li @click="confirmFilter(2, item)" v-for="item in timeData" :class="{'testcol':filterTime.name == item.name}">
          {{item.name}}
          <i class="icon-duihao iconfont click" v-if="filterTime.name == item.name"></i>
        </li>
      </ul>
    </div> -->



    <ul class="listtest">
      <!-- <div v-if="!data.length" style="text-align:center;padding-top:40px;background-color:#fff;">暂无数据</div> -->
      <nodata v-if="!data.length"></nodata>
      <li v-for="item in data" @click="toDetail(item)">
        <div class="title">
          <p>{{item.first_party}}·{{item.pname}}</p>
          <span>{{item.uname}}</span>
          <span>销售金额：¥{{item.tmony}}</span>
          <span>签约时间：{{item.create_date}}</span>
        </div>
      </li>

    </ul>





  </div>
</template>

<script>
  import nodata from './public/nodata'
  import '../assets/css/drillStyle.css'
  import slotsList from '../assets/js/slotsList'
  import dateChange from '../mixins/dateChange.js'
  import regionChange from '../mixins/regionChange.js'

  export default {
    mixins: [dateChange, regionChange],
    components: {
      nodata
    },
    data () {
      return {
        begin_time: null,
        end_time: null,
        region: [],

        isFilter: false,


        // filterArea:{name:'全国',id:0},
        // filterTime:{},
        // regionData:[{id:0,name:'全国'},{id:1,name:'深圳'},{id:2,name:'珠海'},{id:3,name:'上海'},{id:4,name:'北京'},{id:5,name:'成都'},{id:6,name:'海南'}],
        // timeData:[],
        data: [],
        // isFilter:false,
        // filterType:null,
      }
    },
    methods: {
      // showFilter (type) {
      //   this.isFilter = true
      //   this.filterType = type
      // },
      back () {
        // this.$router.go(-1)
        this.$router.push({ name: 'businessmon' })
      },

      filter () { //显示过滤
        this.slots = slotsList.Monthslots(this.begin_time, this.end_time)
        this.isFilter = true
        this.$emit('inFilter')
      },

      confirmFilter () { //确定过滤
        this.begin_time = this.c_begin_time
        this.end_time = this.c_end_time
        this.region = this.c_region
        let data = {
          begin_time: this.begin_time,
          end_time: this.end_time,
          region: this.region
        }
        this.isFilter = false
        this.$notice.loading()
        this.getData(data)
        this.$emit('noFilter')
      },

      cancel () { //点击阴影取消
        this.c_region = this.region
        this.isFilter = false
        this.$emit('noFilter')
      },
      // getTime () {
      //     var d = new Date()
      //     var result = []
      //     var y = d.getFullYear()
      //     var m = d.getMonth() + 1
      //     m = m < 10 ? "0" + m : m
      //     result.push({name:`${y}/${m}`,value:`${y}${m}`})
      //     for(var i = 0; i < 12; i++) {
      //         d.setMonth(d.getMonth() - 1)
      //         var m = d.getMonth() + 1
      //         m = m < 10 ? "0" + m : m
      //         result.push({name:`${d.getFullYear()}/${m}`, value:`${d.getFullYear()}${m}`});
      //     }
      //     return result;
      // },
      getData (data) {
        this.$notice.loading()
        this.$http.getMakeInfo(data).then(res => {
          this.data = res.data
          this.$notice.loading(false)
        })
      },
      toDetail (data) {
        this.$router.push({ name: 'analyzeclick', params: { data: data } })
        console.log(data)
      },
    },
    created () {
      // this.timeData = this.getTime()
      // this.filterTime = this.timeData[0]
      // let data = {
      //   region_id: 0,
      //   time: this.timeData[0].value
      // }
      // this.getData(data)

      let data = JSON.parse(window.localStorage.getItem('drillData'))
      let { begin_time, end_time, region } = data

      this.begin_time = begin_time
      this.end_time = end_time
      this.region = this.c_region = region

      this.getData(data)

    },
  }
</script>

<style lang="css" scoped>
  .container {
    width: 100%;
    background-color: #fff;
  }
  .header {
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 1.04375rem;
    line-height: 1.09375rem;
    position: relative;
    z-index: 99;
  }
  .header p {
    color: #333;
    font-size: 0.4375rem;
  }
  .select {
    width: 100%;
    color: #fff;
    height: 1.1875rem;
    background: #5483d2;
    font-size: 0.4375rem;
    line-height: 1.1875rem;
    padding-left: 0.34375rem;
    margin-bottom: 0.1875rem;
    position: relative;
    clear: both;
  }
  .select .icon {
    font-size: 0.5rem;
    position: absolute;
    right: 0.5rem;
    top: 0;
    margin: auto;
    color: #fff;
  }

  .listtest {
    width: 100%;
    margin: auto;
    background: #fafafa;
    height: 100%;
    padding-top: 0.3125rem;
  }
  .title {
    color: #333;
    position: relative;
    font-size: 0.4375rem;
    background: #fff;
    height: 100%;
    border-radius: 0.0625rem;
  }
  .title p {
    border-left: 3px solid #5483d2;
    border-radius: 0.0625rem;
    padding-left: 0.34375rem;
    margin-bottom: 0.34375rem;
    font-family: PingFangSC-Regular;
    height: 0.9375rem;
    line-height: 0.9375rem;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .title span {
    color: #5482d2;
    font-size: 0.34375rem;
    padding-left: 3%;
    display: block;
    font-family: PingFangSC-Regular;
  }
  .listtest li {
    position: relative;
    width: 100%;
    margin: auto;
    background: #fafafa;
    margin-bottom: 0.3125rem;
    height: 3.025rem;
  }
  .listtest li p span {
    color: #5482d2;
    display: block;
    font-size: 0.34375rem;
  }
  .listtest li p span:nth-child(1) {
    margin-top: 2%;
  }

  .back {
    /*transform: rotate(90deg);*/
    display: inline-block;
    position: absolute;
    left: 2%;
    top: 12%;
    height: 0.78125rem;
    line-height: 0.78125rem;
    color: #86898e;
    font-size: 0.4375rem;
    font-weight: bolder;
    z-index: 2;
  }

  .down {
    position: absolute;
    top: 30%;
    right: 5%;
    color: #5483d2;
    transform: rotate(-90deg);
  }
  .yes {
    color: #333333 !important;
    font-size: 0.3125rem !important;
    font-weight: 500;
  }
  .zhezhao {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9;
    width: 100%;
    height: 100%;
  }
  .downlist {
    position: absolute;
    z-index: 99;
    width: 100%;
  }
  .downlist ul {
    width: 100%;
    height: 6.15rem;
    overflow: scroll;
    background: #fff;
    color: #333333;
    font-size: 0.34375rem;
  }
  .downlist ul li {
    height: 1.046875rem;
    line-height: 1.046875rem;
    padding-left: 0.4375rem;
    border-bottom: 1px solid #cccccc;
    position: relative;
  }
  .click {
    position: absolute;
    top: 30%;
    right: 3.5%;
  }
  .testcol {
    color: #5483d2;
  }
  .click {
    font-size: 0.3125rem;
    position: absolute;
    top: 0.0625rem;
    right: 3.5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Analyze.vue